// extracted by mini-css-extract-plugin
module.exports = {"tabList":"TabList-module--tab-list---GMgF"};